import { toast } from "react-toastify";

export const errorToast = (text: any, options?: any): void => {
  toast.error(text, options);
};

export const successToast = (text: any, options?: any): void => {
  toast.success(text, options);
};
